export default {
  placeholder: 'Choose vehicle type',
  label: 'Vehicle type',
  defaultOption: {
    label: 'any',
    imgAlt: 'car image',
  },
};
